<template>
  <v-flex xs12>
    <v-form>
      <v-container>
        <v-row>
          <v-col class="d-flex flex-row justify-center align-center newsletter-wrapper">
            <v-text-field label="Email Address" prepend-inner-icon="email"></v-text-field>
            <v-btn class="ma-2" tile outlined color="success">Submit</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-flex>
</template>

<script>
export default {
  name: "NewsLetter"
};
</script>
<style>
.newsletter-wrapper {
	width: 380px;
	max-width: 100%;
	margin: 0 auto;
}

.newsletter-wrapper .v-input .v-input__slot::before {
	border-color: #d9dfe0;
	border-width: 1px;
}

.newsletter-wrapper .v-input .v-input__slot i {
	color: #d9dfe0;
}

.newsletter-wrapper button {
	background-color: #ec1c23 !important;
	border-color: #ec1c23 !important;
	border-radius: 5px;
	text-transform: uppercase;
	padding-left: 10px;
	padding-right: 10px;
}

.newsletter-wrapper button .v-btn__content::after {
	content: ' ';
  display: inline-block;
  position: relative;
  margin-left: 5px;
  border-style: solid;
  border-color: #fff;
	border-width: 3px 3px 0 0;
	display: inline-block;
	height: 8px;
  width: 8px;
	transform: rotate(45deg);
	vertical-align: top;
}

</style>
